import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from './../external_lib/d3-interpolate/external_lib/d3-color/src/index.js';
var require$$0 = /*@__PURE__*/getAugmentedNamespace(index);
export { require$$0 as default };
//# sourceMappingURL=index8.js.map
